export default "__VITE_ASSET__f94ff2df__"